<template>
  <div class="imgCropper">
    <tk-flex wrap :gutter="12">
      <!-- <ak-type-input ref="storePhoto" v-model="fileList" :field="storePhotoOptions"/> -->
      <viewer v-if="fileList.length" :images="fileList">
        <tk-flex wrap :gutter="12">
          <div style="position: relative; background-color: #fafafa;border: 1px dashed #CBD0D9;" v-for="(t,i) in fileList" :key="i">
            <img
              :src="t"
              style="width: 120px;height:120px;object-fit:contain;margin-right: 5px"
            />
            <tk-flex
              middle center
              class="deleteIcon"
               @click.native="deleteImage(i)"
              >
              <a-icon type="close" style="color: white;fontSize:14px"/>
            </tk-flex>
          </div>
        </tk-flex>
      </viewer>
      <a-upload
        accept=".jpg,.jpeg,.png,.webp,.gif,.bmp"
        v-if="fileList.length < 6"
        listType="picture-card"
        class="avatar-uploader"
        :showUploadList="false"
        :beforeUpload="beforeUpload"
        @change="handleChange"
      >
        <!-- <img class="default-img" v-if="imageUrl" :src="imageUrl"/> -->
        <div v-if="fileList.length < 6">
          <a-icon :type="loading ? 'loading' : 'cloud'" />
          <div class="ant-upload-text">点击上传</div>
        </div>
      </a-upload>
    </tk-flex>
    <!-- modal -->
    <cropper-modal ref="cropperModal" @ok="handleCropperSuccess" @cancel="cancel"></cropper-modal>
  </div>

</template>
<script>
import cropperModal from './cropperModal'
// import config from '@/config'
export default {
  name: 'imgCropper',
  components: {
    cropperModal
  },
  props: {
    // 回显图片路径
    imgList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      imageUrl: '',
      fileList: []
    }
  },
  watch: {
    value: {
      handler (val) {
        this.imageUrl = val || ''
      },
      immediate: true
    }
  },
  mounted () {
    this.fileList = this.imgList
  },
  methods: {
    // action (file) {
    //   return `${config.apiUrl}/files?filename=${file.name}`
    // },
    // 从本地选择文件
    handleChange (info) {
      console.log(info)
      let { options } = this
      this.blobToBase64(info.file.originFileObj, (imageUrl) => {
        let target = Object.assign({}, options, {
          img: imageUrl,
          fileName: info.file.name
        })
        this.$refs['cropperModal'].edit(target)
      })
    },
    // 上传之前 格式与大小校验
    beforeUpload (file) {
      return true
    },
    // 裁剪成功后的File对象
    async handleCropperSuccess (data) {
      try {
        this.loading = true
        console.log('File:', data)
        let arrayBuffer = await data.arrayBuffer()
        console.log(arrayBuffer)
        const res = await this.$tkParse.post('/files', arrayBuffer)
        this.$message.success('上传成功')
        // 将返回的数据回显
        this.fileList.push(res.data.url)
        console.log(this.fileList)
        this.loading = false
        this.$emit('uploadSuc', this.fileList)
      } catch (e) {
        this.loading = false
      }
    },
    blobToBase64 (blob, callback) {
      const reader = new FileReader()
      reader.addEventListener('load', () => {
        callback(reader.result)
      })
      reader.readAsDataURL(blob)
    },
    deleteImage (i) {
      console.log(i)
      this.fileList.splice(i, 1)
      this.$emit('uploadSuc', this.fileList)
    },
    cancel () {}
  }
}
</script>
<style lang="scss" scoped>
  .deleteIcon{
    position: absolute;
    top: -5px;
    right: -5px;
    background: red;
    width: 20px;
    height: 20px;
    z-index: 100;
    border-radius: 50%;
    cursor: pointer;
  }
::v-deep{
  .tk-flex-box{
    overflow: visible !important;
  }
  .tk-flex{
    overflow: visible !important;
  }
  .ant-upload-picture-card-wrapper{
    width: 120px;
    height: 120px;
    .ant-upload.ant-upload-select-picture-card{
      width: 118px;
      height: 118px;
      border: 1px dashed #CBD0D9;
    }
    .ant-upload.ant-upload-select-picture-card > .ant-upload{
      width: 118px;
      height: 118px;
    }
  }
}
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
</style>
